import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-ribbon',
  templateUrl: './ribbon.component.html',
  styleUrls: ['./ribbon.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class RibbonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/features/ribbon/ribbon.component.ts